module.exports = __webpack_public_path__ + "media/auto_history/pierwszy_wlasciciel-d010e87a.png";